import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	filters: {
		defaultMessage: 'Filters',
		id: 'atlassian-navigation.filters.filters',
		description: 'Filters',
	},
});
